import { grey } from "@mui/material/colors";
import { HEART_COLOR } from "styles/oneOffColor";

const styles = {
  savedHeart: {
    color: HEART_COLOR,
    fontSize: 16,
  },
  regularHeart: {
    fontSize: 16,
  },
  icon: {
    fontSize: 14,
    width: "30px",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    color: grey[900],
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.7)",
    },
  },
  notifyLabel: {
    "> .MuiFormControlLabel-label": {
      color: grey[700],
      fontSize: 12,
    },
  },
  notifyLabelHeader: {
    borderRadius: "30px",
    height: "28px",
    pl: 1,
    "> .MuiFormControlLabel-label": {
      color: "black",
      fontSize: 12,
    },
    backgroundColor: "rgba(255, 255, 255, 0.7)",
  },
  switch: {
    fontSize: 12,
    "& .MuiSwitch-switchBase": {
      "&.Mui-checked": {
        color: "#fff",
        "& .MuiSwitch-thumb:before": {
          content: "'\\f0f3'",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: "primary.main",
      fontFamily: "'Font Awesome 6 Pro'",
      "&::before": {
        content: "'\\f1f6'",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      },
    },
  },
  quickSendButton: {
    textTransform: "none",
    color: "white",
    mx: 1,
    fontSize: 12,
  },
};

export default styles;
